import { ContentLoadingView } from '@northladder/design-system';

import { translations } from '../../translations';

/**
 * -----------------------------------------------------------------------------
 * This is rendered while the app is retrieving the images list from the provided
 * sessionId in the url on first launch or refresh.
 */
export function DeviceImagesListLoading() {
  // TODO: Get these from messages/locale.json
  const { title, subTitle } = translations.deviceListLoading;

  return <ContentLoadingView subTitle={subTitle} title={title} />;
}
